<div class="documents-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 margin-align">
    <h4 class="margin-header-align text-uppercase">{{ 'documents.page-title' | translate }}</h4>
    <hr />
  </div>

  <div
    *ngIf="documentsData.length && userRole.toUpperCase() === userStatus.STANDARDTECHNICIAN"
    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 content-section">
    <ng-container *ngFor="let item of documentsList">
      <div class="document-section">
        <div class="section-title">{{ 'overview.details-data.section-titles.' + item.id | translate }}</div>

        <div *ngFor="let object of item.data; let index = index" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 form-column">
          <div
            [ngClass]="{ 'disabled-text-color': checkForAvailableDocuments(object) }"
            class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 margin-align document-background">
            <label class="row-documents-label ui-g-12 ui-xl-5 ui-lg-5 ui-md-5 ui-sm-12 margin-align">
              {{ 'basic-profile.fields.' + object | translate }}
            </label>
            <div *ngIf="!checkForAvailableDocuments(object)" class="file-name-view-box ui-g-12 ui-xl-7 ui-lg-5 ui-md-7 ui-sm-12">
              <span class="file-name ui-g-9 text-center">{{ getFileName(object) }}</span>
              <button
                (click)="downloadFile(object)"
                class="ui-g-3 view-btn"
                id="docs-download-btn-{{ index }}"
                label="{{ 'view-button-label' | translate }}"
                pButton
                type="button"></button>
            </div>
            <div *ngIf="checkForAvailableDocuments(object)" class="text-center">-</div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container>
      <div class="document-section">
        <div class="section-title">{{ 'overview.details-data.section-titles.other-documents' | translate }}</div>

        <div *ngFor="let object of documentsData; let index = index" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 form-column">
          <div *ngIf="verifyFilename(object.name)">
            <div
              [ngClass]="{ 'disabled-text-color': checkForAvailableDocuments(object.name) }"
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 margin-align document-background">
              <label class="row-documents-label ui-g-12 ui-xl-5 ui-lg-5 ui-md-5 ui-sm-12 margin-align">
                {{ 'basic-profile.fields.' + object.name | translate }}
              </label>
              <div *ngIf="!checkForAvailableDocuments(object.name)" class="file-name-view-box ui-g-12 ui-xl-7 ui-lg-5 ui-md-7 ui-sm-12">
                <span class="file-name ui-g-9 text-center">{{ getFileName(object.name) }}</span>
                <button
                  (click)="downloadFile(object.name)"
                  class="ui-g-3 view-btn"
                  id="other-docs-download-btn-{{ index }}"
                  label="{{ 'view-button-label' | translate }}"
                  pButton
                  type="button"></button>
              </div>
              <div *ngIf="checkForAvailableDocuments(object.name)" class="text-center">-</div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div
    *ngIf="documentsData.length && userRole.toUpperCase() === userStatus.GUESTTECHNICIAN"
    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 content-section">
    <ng-container>
      <div class="document-section">
        <div class="section-title">{{ 'overview.details-data.section-titles.network-permissions' | translate }}</div>

        <div *ngFor="let object of documentsData; let index = index" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 form-column">
          <div
            *ngIf="object.name === 'welding_certificate_confirmation'"
            [ngClass]="{ 'disabled-text-color': checkForAvailableDocuments(object.name) }"
            class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 margin-align document-background">
            <label class="row-documents-label ui-g-12 ui-xl-5 ui-lg-5 ui-md-5 ui-sm-12 margin-align">
              {{ 'basic-profile.fields.' + object.name | translate }}
            </label>
            <div *ngIf="!checkForAvailableDocuments(object.name)" class="file-name-view-box ui-g-12 ui-xl-7 ui-lg-5 ui-md-7 ui-sm-12">
              <span class="file-name ui-g-9 text-center">{{ getFileName(object.name) }}</span>
              <button
                (click)="downloadFile(object.name)"
                class="ui-g-3 view-btn"
                id="docs-permission-download-btn"
                label="{{ 'view-button-label' | translate }}"
                pButton
                type="button"></button>
            </div>
            <div *ngIf="checkForAvailableDocuments(object.name)" class="text-center">-</div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container>
      <div class="document-section">
        <div class="section-title">{{ 'basic-profile.fields.take_mandatory_documents' | translate }}</div>

        <div *ngFor="let object of documentsData; let index = index" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 form-column">
          <div
            *ngIf="object.name === 'id_card_main_fraud'"
            [ngClass]="{ 'disabled-text-color': checkForAvailableDocuments(object.name) }"
            class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 margin-align document-background">
            <label class="row-documents-label ui-g-12 ui-xl-5 ui-lg-5 ui-md-5 ui-sm-12 margin-align">
              {{ 'basic-profile.fields.' + object.name | translate }}
            </label>
            <div *ngIf="!checkForAvailableDocuments(object.name)" class="file-name-view-box ui-g-12 ui-xl-7 ui-lg-5 ui-md-7 ui-sm-12">
              <span class="file-name ui-g-9 text-center">{{ getFileName(object.name) }}</span>
              <button
                (click)="downloadFile(object.name)"
                class="ui-g-3 view-btn"
                id="mandatory-docs-download-btn"
                label="{{ 'view-button-label' | translate }}"
                pButton
                type="button"></button>
            </div>
            <div *ngIf="checkForAvailableDocuments(object.name)" class="text-center">-</div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container>
      <div class="document-section">
        <div class="section-title">{{ 'basic-profile.fields.other_documents' | translate }}</div>

        <div *ngFor="let object of documentsData; let index = index" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 form-column">
          <div *ngIf="verifyFilename(object.name)">
            <div
              [ngClass]="{ 'disabled-text-color': checkForAvailableDocuments(object.name) }"
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 margin-align document-background">
              <label class="row-documents-label ui-g-12 ui-xl-5 ui-lg-5 ui-md-5 ui-sm-12 margin-align">
                {{ object.name }}
              </label>
              <div *ngIf="!checkForAvailableDocuments(object.name)" class="file-name-view-box ui-g-12 ui-xl-7 ui-lg-5 ui-md-7 ui-sm-12">
                <span class="file-name ui-g-9 text-center">{{ getFileName(object.name) }}</span>
                <button
                  (click)="downloadFile(object.name)"
                  class="ui-g-3 view-btn"
                  id="docs-others-download-btn-{{ index }}"
                  label="{{ 'view-button-label' | translate }}"
                  pButton
                  type="button"></button>
              </div>
              <div *ngIf="checkForAvailableDocuments(object.name)" class="text-center">-</div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div *ngIf="userRole.toUpperCase() === userStatus.CUSTOMER" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 content-section">
    <div class="document-section">
      <div class="section-title">{{ 'overview.process-details.customer-offer-title' | translate }}</div>

      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 form-column" *ngIf="offerDocuments.length">
        <ng-container *ngFor="let document of offerDocuments">
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 margin-align document-background">
            <label class="row-documents-label ui-g-5 ui-xl-5 ui-lg-5 ui-md-7 ui-sm-12">
              {{ ('overview.process-details.customer-standard-offer' | translate) + ' ' + document.application_ext_id }}
            </label>
            <div class="file-name-view-box ui-g-7 ui-xl-7 ui-lg-5 ui-md-7 ui-sm-12">
              <span class="file-name ui-g-9 text-center">{{ document.filename }}</span>
              <button
                class="ui-g-3 view-btn"
                label="{{ 'view-button-label' | translate }}"
                pButton
                (click)="downloadDocument(document.document_id, document.filename)"
                type="button"></button>
            </div>
          </div>
        </ng-container>
      </div>
      <div *ngIf="!offerDocuments.length" class="text-center">-</div>
    </div>

    <div class="document-section">
      <div class="section-title">{{ 'overview.process-details.customer-order-title' | translate }}</div>

      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 form-column" *ngIf="orderDocuments.length">
        <ng-container *ngFor="let document of orderDocuments">
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 margin-align document-background">
            <label class="row-documents-label ui-g-5 ui-xl-5 ui-lg-5 ui-md-7 ui-sm-12">
              {{ ('overview.process-details.customer-order' | translate) + ' ' + document.application_ext_id }}
            </label>
            <div class="file-name-view-box ui-g-7 ui-xl-7 ui-lg-5 ui-md-7 ui-sm-12">
              <span class="file-name ui-g-9 text-center">{{ document.filename }}</span>
              <button
                class="ui-g-3 view-btn"
                label="{{ 'view-button-label' | translate }}"
                pButton
                (click)="downloadDocument(document.document_id, document.filename)"
                type="button"></button>
            </div>
          </div>
        </ng-container>
      </div>
      <div *ngIf="!orderDocuments.length" class="text-center">-</div>
    </div>

    <div class="document-section">
      <div class="section-title">{{ 'overview.process-details.customer-invoice-title' | translate }}</div>

      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 form-column" *ngIf="invoiceDocuments.length">
        <ng-container *ngFor="let document of invoiceDocuments">
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 margin-align document-background">
            <label class="row-documents-label ui-g-5 ui-xl-5 ui-lg-5 ui-md-5 ui-sm-12">
              {{ ('overview.process-details.customer-invoice' | translate) + ' ' + document.application_ext_id }}
            </label>
            <div class="file-name-view-box ui-g-7 ui-xl-7 ui-lg-5 ui-md-7 ui-sm-12">
              <span class="file-name ui-g-9 text-center">{{ document.filename }}</span>
              <button
                class="ui-g-3 view-btn"
                label="{{ 'view-button-label' | translate }}"
                pButton
                (click)="downloadDocument(document.document_id, document.filename)"
                type="button"></button>
            </div>
          </div>
        </ng-container>
      </div>
      <div *ngIf="!invoiceDocuments.length" class="text-center">-</div>
    </div>
  </div>
</div>
<p-confirmDialog
  #confirmDialog
  icon="pi pi-info-circle"
  message="{{ 'overview.process-details.confirmation-text' | translate }}"
  styleClass="netz-confirm-dialog">
  <p-footer>
    <button (click)="confirmDialog.accept()" label="{{ 'yes-button-label' | translate }}" pButton type="button"></button>
    <button (click)="confirmDialog.reject()" label="{{ 'no-button-label' | translate }}" pButton type="button"></button>
  </p-footer>
</p-confirmDialog>
<app-loader *ngIf="isLoading"></app-loader>
